// removed by extract-text-webpack-plugin
module.exports = {"CashTransferNote":"CashTransferNote","accordion":"accordion","card":"card"};


//////////////////
// WEBPACK FOOTER
// ./src/components/areas/Account/CashTransfer/Common/CashTransferNote/styles.scss
// module id = 2217
// module chunks = 10